<template>
  <QueryFilter @search="onSearch" />
  <div class="list">
    <div v-for="item of list" :key="item.id" class="item">
      <div class="ic withdraw"><van-icon name="balance-o" /></div>
      <div class="mid">
        <div class="title">{{ $t('query.withdrawAmount').replace(':', '') }}</div>
        <div class="time">{{ $filters.formatDate(item.createdAt) }}</div>
      </div>
      <div class="amt-withdraw">- ₡{{ item.amount }}</div>
    </div>
    <div v-if="list.length < total" class="load-more" @click="getMore">{{ $t('common.loadMore') }}</div>
    <div v-if="list.length === 0" class="empty">
      <van-icon name="records" class="empty-icon" />
      <div>{{ $t('common.noData') }}</div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { WithdrawService } from '@/services';
import QueryFilter from './QueryFilter.vue';

const list = ref([]);
const total = ref(0);
const pageNumber = ref(1);
const isQuery = ref(false);
const filter = ref({ startTime: '', endTime: '' });

const initResult = async () => {
  const { result } = await WithdrawService.withdrawListApi({
    pageNumber: pageNumber.value,
    startTime: filter.value.startTime,
    endTime: filter.value.endTime,
  });
  if (isQuery.value) {
    list.value = result.data || [];
    isQuery.value = false;
  } else if (result.data && result.data.length) {
    list.value = [...list.value, ...result.data];
  } else if (pageNumber.value === 1) {
    list.value = [];
  }
  total.value = result.total;
};
const getMore = () => {
  pageNumber.value += 1;
  initResult();
};
const onSearch = (v) => {
  isQuery.value = true;
  pageNumber.value = 1;
  filter.value = v;
  initResult();
};
onMounted(initResult);
</script>

<style lang="scss" scoped>
.list {
  padding: 0 16px;
}
.item {
  display: flex;
  align-items: center;
  background: #fff;
  border-radius: 16px;
  padding: 18px 24px;
  margin-bottom: 14px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  .ic {
    width: 72px;
    height: 72px;
    border-radius: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-size: 34px;
    margin-right: 20px;
    flex-shrink: 0;
    &.withdraw {
      background: linear-gradient(135deg, #fbbf24, #f59e0b);
    }
  }
  .mid {
    flex: 1;
    .title {
      font-size: 28px;
      color: var(--text-primary);
      font-weight: 500;
      margin-bottom: 6px;
    }
    .time {
      font-size: 22px;
      color: var(--text-muted);
    }
  }
  .amt-withdraw {
    font-size: 32px;
    font-weight: 700;
    color: #f59e0b;
  }
}
.load-more {
  text-align: center;
  color: var(--brand-primary);
  font-size: 26px;
  padding: 24px;
  cursor: pointer;
}
.empty {
  text-align: center;
  color: var(--text-muted);
  padding: 120px 0;
  font-size: 26px;
  .empty-icon {
    font-size: 100px;
    margin-bottom: 16px;
    opacity: 0.5;
  }
}
</style>
